import { useNavigate } from "react-router-dom";
import { useAuthController } from "../auth-provider";

export function useLogout() {
    const navigate = useNavigate();
    const authController = useAuthController();

    const logout = async () => {
        try {
            await authController.logout();
            navigate("/login");
        } catch (error) {
            console.error(error);
        }
    };

    return logout;
}
